import React from 'react';
import fr from 'facet-rest';
import { pickFunction } from 'Helpers/Affordances';

import useUserContext from 'Context/UserContext';
import LabelWithPreferredName
  from 'Components/AdvisorApp/Viewport/Household/LandingPage/Demographics/SecondaryClientLabelPicker/LabelWithPreferredName';

const SecondaryClientLabelPicker = ({ secondaryClientLabel, secondaryClient }) => {
  const { userResource } = useUserContext();

  return pickFunction(userResource, {
    [fr.relationships.default.name]: () => (
      <LabelWithPreferredName secondaryClientLabel={secondaryClientLabel} secondaryClient={secondaryClient} />
    ),
  });
};

export default SecondaryClientLabelPicker;
